'use strict';

class GrpCtxCtrl {
  constructor($stateParams, GroupAuthSvc) {
    var that = this;
    var ctxId = $stateParams.ctxId;
    this.ctxId = ctxId;
    GroupAuthSvc.getPermissionChecker(ctxId, 'group', 'I')
      .then(function(hasCtxGrpPerm) {
        that.hasCtxGrpPerm = hasCtxGrpPerm;
      });
  }
}

GrpCtxCtrl.$inject = ['$scope', '$state', 'GroupSvc', 'LoaderSvc'];

export default ['$stateParams', 'GroupAuthSvc', GrpCtxCtrl];
